import * as React from 'react';

import {
  ICsvImportConfigurationProps,
  ICsvImportForeignKeyConfigurationProps,
} from './CsvImportConfiguration';

export const useCsvImportForeignKeyConfig = (options: {
  defaultForeignKey: string;
  defaultImportType: string;
  onConfigChange?: (importType: string, foreignKey: string) => void;
}): Omit<
  ICsvImportConfigurationProps,
  'foreignKeyConfig' | 'importTypeOptions'
> & {
  foreignKeyConfig: Omit<
    ICsvImportForeignKeyConfigurationProps,
    'foreignKeyOptions'
  >;
} => {
  const { defaultForeignKey, defaultImportType, onConfigChange } = options;
  const [importType, setImportType] = React.useState(defaultImportType);
  const [foreignKey, setForeignKey] = React.useState(defaultForeignKey);

  React.useEffect(() => {
    onConfigChange && onConfigChange(importType, foreignKey);
  }, [importType, foreignKey, onConfigChange]);

  return {
    importType,
    onImportTypeChange: (importType) => setImportType(importType),
    foreignKeyConfig: {
      onForeignKeyChange: (value) => setForeignKey(value),
      foreignKey,
    },
  };
};

export const useCsvImportConfig = (options: {
  defaultImportType: string;
  onConfigChange?: (importType: string) => void;
}): Omit<
  ICsvImportConfigurationProps,
  'foreignKeyConfig' | 'importTypeOptions'
> => {
  const { defaultImportType, onConfigChange } = options;
  const [importType, setImportType] = React.useState(defaultImportType);

  React.useEffect(() => {
    onConfigChange && onConfigChange(importType);
  }, [importType, onConfigChange]);

  return {
    importType,
    onImportTypeChange: (importType) => setImportType(importType),
  };
};
